import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import { relatedPages } from "../../data/routes";
import { SectionHeading } from "./SectionHeading";
type RelatedPagesProps = {
  current: string;
};
export function RelatedPages({
  current
}: RelatedPagesProps) {
  const pages = relatedPages.filter(page => page.to !== current).slice(0, 3);
  return <section className="bg-white py-8 lg:py-14" aria-labelledby="related-title" data-id="element-256" data-mp="3925l9tz7r7ky">
      <div className="mx-auto max-w-[1320px] px-5 lg:px-10" data-id="element-257" data-mp="342sxn70ipwhb">
        <SectionHeading id="related-title" eyebrow="KEEP EXPLORING" title="Related Rinnai air conditioning guides" data-id="element-258" data-mp="34181jcyk25hc" />
        <div className="mt-10 grid gap-6 md:grid-cols-3" data-id="element-259" data-mp="302skrqt2htcd">
          {pages.map(page => <Link key={page.to} to={page.to} className="group flex h-full flex-col rounded-lg border border-line bg-white p-7 transition-colors duration-150 ease-out hover:border-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rinnai focus-visible:ring-offset-2" data-id="element-260" data-mp="2v3xts1ky4yh6">
              <h3 className="text-xl font-bold tracking-tight text-ink" data-id="element-261" data-mp="hllru0xn23lm">{page.title}</h3>
              <p className="mt-3 text-sm leading-6 text-muted" data-id="element-262" data-mp="3m3xz75hk05e">{page.text}</p>
              <span className="mt-auto inline-flex items-center gap-2 pt-6 text-sm font-bold text-rinnai" data-id="element-263" data-mp="3nx32i0gacba">
                Read the guide
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-264" data-mp="w9zuobv21s26" />
              </span>
            </Link>)}
        </div>
      </div>
    </section>;
}